import React from "react";
import ExerciseSaleFilter from "./ExerciseSaleFilter";
import { ExerciseSaleSearchParams } from "../../models/ExerciseSaleSearchParams";
import { searchExerciseSale } from "../../store/exerciseSaleFilters/exerciseSaleFiltersActions";
import LoadableComponent from "../../shared/Loading/LoadableComponent";
import { Divider, Grid } from "@material-ui/core";
import ExerciseSaleHeader from "./ExerciseSaleHeader";
import ExerciseSaleButtonSet from "./ExerciseSaleButtonSet";
import { Exercise } from "../../models/Exercise";
import { selectExercise } from "../../store/basket/basketActions";
import useWithDispatch from "../../utils/hook/withDispatchHook";
import Navigator from "../../shared/Navigator";
import { ExerciseSaleModel } from "../../models/ExerciseSaleModel";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { setErrors } from "../../store/alerts/alertsActions";
import Hidden from "@material-ui/core/Hidden";

const styleContainer = { padding: "2%", marginBottom: 100 };

interface IProps {
  activeStep: number;
  lengthStepper: number;
  loading: boolean;
  searchParams: ExerciseSaleSearchParams;
  exercisesSale: ExerciseSaleModel[];
  setActiveStep: (value: number) => void;
  getTicket: () => void;
}

const ExerciseSaleView: React.FC<IProps> = ({
  activeStep,
  lengthStepper,
  loading,
  searchParams,
  exercisesSale,
  setActiveStep,
  getTicket,
}: IProps) => {
  const witchDispatch = useWithDispatch();
  const exerciseSelect = useSelector((state: State) => state.basket.exerciseSelect);

  const handleClickNext = () => {
    if (exerciseSelect.length > 0) {
      setActiveStep(activeStep + 1);
      getTicket();
    } else {
      witchDispatch(setErrors)(["Aby przejść dalej wybierz zajęcie"]);
    }
  };

  return (
    <React.Fragment>
      <ExerciseSaleFilter
        searchParams={searchParams}
        setSearchParams={(value: ExerciseSaleSearchParams) => witchDispatch(searchExerciseSale)({ search: value })}
        loading={loading}
      />
      <LoadableComponent loading={loading}>
        <div style={styleContainer}>
          {exercisesSale.map((item, index) => (
            <Grid key={index} container spacing={4}>
              <Grid item xs={12}>
                <ExerciseSaleHeader
                  name={item.name}
                  startDate={new Date(item.exercises[0].startTime)}
                  endDate={new Date(item.exercises[item.exercises.length - 1].closeTime)}
                />
              </Grid>
              <Grid container item xs={12} spacing={2}>
                {item.exercises.map((exerciseItem) => (
                  <React.Fragment key={exerciseItem.objectId}>
                    <Hidden mdDown>
                      <Grid item xs={2}>
                        <ExerciseSaleButtonSet
                          exercise={exerciseItem}
                          onBtnClick={(exercise: Exercise) => witchDispatch(selectExercise)(exercise)}
                        />
                      </Grid>
                    </Hidden>
                    <Hidden lgUp>
                      <Grid item xs={4}>
                        <ExerciseSaleButtonSet
                          exercise={exerciseItem}
                          onBtnClick={(exercise: Exercise) => witchDispatch(selectExercise)(exercise)}
                        />
                      </Grid>
                    </Hidden>
                  </React.Fragment>
                ))}
                <Divider style={{ marginTop: "10px" }} />
              </Grid>
            </Grid>
          ))}
        </div>
      </LoadableComponent>

      <Navigator
        lengthStepper={lengthStepper}
        activeStep={activeStep}
        onClickNext={() => handleClickNext()}
        onClickPrev={() => setActiveStep(activeStep - 1)}
      ></Navigator>
    </React.Fragment>
  );
};

export default ExerciseSaleView;
